import React from "react";
import { Link, useLocation } from "react-router-dom";
import { APP_VERSION } from "../../utils/constant";
import ThemeToggelSwitch from "./ThemeToggelSwitch";
import { ROUTES } from "../../utils/key_helper";
const Sidebar = () => {
	const location = useLocation();

	const isPathActive = (path) => {
		return location.pathname.startsWith(path);
	};

	const onRouteChanged = () => {
		document.querySelector("#sidebar").classList.remove("active");
	};

	React.useEffect(() => {
		onRouteChanged();

		// Add hover effect for sidebar icon-only mode
		const body = document.querySelector("body");
		const navItems = document.querySelectorAll(".sidebar .nav-item");

		navItems.forEach((el) => {
			el.addEventListener("mouseover", () => {
				if (body.classList.contains("sidebar-icon-only")) {
					el.classList.add("hover-open");
				}
			});
			el.addEventListener("mouseout", () => {
				if (body.classList.contains("sidebar-icon-only")) {
					el.classList.remove("hover-open");
				}
			});
		});

		return () => {
			navItems.forEach((el) => {
				el.removeEventListener("mouseover", () => { });
				el.removeEventListener("mouseout", () => { });
			});
		};
	}, [location.pathname]);

	return (
		<nav className="sidebar sidebar-offcanvas fixed-sidebar" id="sidebar">
			<div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
				<a className="sidebar-brand brand-logo" href="index.html">
					<img src={require("../../assets/images/portal_long.png")} alt="logo" />
				</a>
				<a className="sidebar-brand brand-logo-mini" href="index.html">
					<img src={require("../../assets/images/portal_mini.png")} alt="logo" />
				</a>
			</div>
			<ul className="nav">
				<li className="nav-item nav-category">
					<span className="nav-link pb-0">
						Admin
						<span className="nav-link ml-2 py-0">
							[ {APP_VERSION} ]
						</span>
					</span>
				</li>
				<li className={isPathActive("/dashboard") ? "nav-item menu-items active" : "nav-item menu-items"}>
					<Link className="nav-link" to="/dashboard">
						<span className="menu-icon">
							<i className="mdi mdi-speedometer text-warning"></i>
						</span>
						<span className="menu-title">
							Dashboard
						</span>
					</Link>
				</li>
				<li className={isPathActive(ROUTES.USER_MANAGEMENT) ? "nav-item menu-items active" : "nav-item menu-items"}>
					<Link className="nav-link" to={ROUTES.USER_MANAGEMENT}>
						<span className="menu-icon">
							<i className="mdi mdi-account-group text-info"></i>
						</span>
						<span className="menu-title">
							User Management
						</span>
					</Link>
				</li>

				<li className={isPathActive(ROUTES.STRATEGY) ? "nav-item menu-items active" : "nav-item menu-items"}>
					<Link className="nav-link" to={ROUTES.STRATEGY}>
						<span className="menu-icon">
							<i className="mdi mdi-chart-line text-success"></i>
						</span>
						<span className="menu-title">
							Master Strategy
						</span>
					</Link>
				</li>
				<li className={isPathActive(ROUTES.MAIL_CONFIG) ? "nav-item menu-items active" : "nav-item menu-items"}>
					<Link className="nav-link" to={ROUTES.MAIL_CONFIG}>
						<span className="menu-icon">
							<i className="mdi mdi-tools text-danger"></i>
						</span>
						<span className="menu-title">
							Mail Configs
						</span>
					</Link>
				</li>
			</ul>
		</nav>
	);
};

export default Sidebar;
